import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import CheckIcon from '@assets/img/icons/check.svg?react';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';
import { v4 as uuidv4 } from 'uuid';

import css from './styles.module.scss';

const checkboxVariants = cva('', {
  variants: {
    variant: {
      default: css.default,
      grey: css.greyCheckbox,
    },
  },
});

interface CheckboxProps
  extends InputHTMLAttributes<HTMLInputElement>,
    VariantProps<typeof checkboxVariants> {
  classNames?: {
    check?: string;
    box?: string;
    label?: string;
  };
  checkedIcon?: () => ReactNode | null;
  label?: () => ReactNode | null;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ variant, classNames, checkedIcon, label, ...props }, ref) => {
    const id = uuidv4();

    return (
      <>
        <input
          {...props}
          ref={ref}
          id={props.id || id}
          className={css.input}
          type="checkbox"
        />
        <label htmlFor={props.id || id} className={classNames?.label}>
          <div className={cn(checkboxVariants({ variant }), props.className)}>
            {checkedIcon ? (
              checkedIcon()
            ) : (
              <CheckIcon
                className={cn(
                  'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-1/2 h-auto',
                  !classNames?.check && css.chevronColor,
                  classNames?.check,
                )}
              />
            )}
          </div>
          {label && label()}
        </label>
      </>
    );
  },
);

export { Checkbox };
